import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

// functions
import * as ownFunctions from './CashFlow.General.Functions';

// components
import { PageHeader } from "../../commons/component/PageHeader/PageHeader"
import CashflowGeneralComponent from "../../components/CashFlow/General/Cashflow.General.Component";

const CashFlowGeneralPage = (props: ownFunctions.Props) => {

  const [t] = useTranslation();

  return (
    <>
      <PageHeader eyebrow="Finanzas" title={t('Cashflow.title')} />
      <CashflowGeneralComponent EntityIdentifier={props.OwnerId} FixedAssociatedEntityIdentifier={undefined} />
    </>
  )
}

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(
  CashFlowGeneralPage as any
)
